import { z } from 'zod';

export const addIssue = (
  ctx: {
    addIssue: (issue: z.IssueData) => void;
  },
  path: Array<string | number>,
  message: string,
) => {
  ctx.addIssue({
    code: z.ZodIssueCode.custom,
    path,
    message,
  });
};
